import { Culture } from '../../types';

export const gilaRiver: Culture = {
  name: 'Gila River Indian Community',
  languageFamily: 'Uto-Aztecan',
  terms: [
    {
      word: 'Gila',
      phonetic: 'hee-lah',
      description: 'Derived from the Pima language, referring to the Gila River.'
    },
    {
      word: 'Himdag',
      phonetic: 'heem-dahg',
      description: 'Pima word meaning "way of life" or cultural ethos.'
    },
    {
      word: 'Vainom Kug',
      phonetic: 'vye-nom koog',
      description: 'Phrase for "big mountain."'
    }
  ]
};